import { ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { motion } from 'framer-motion';

interface GlassCardProps {
    children: ReactNode;
    className?: string;
    hoverEffect?: boolean;
    onClick?: () => void;
}

export function GlassCard({ children, className, hoverEffect = true, onClick }: GlassCardProps) {
    return (
        <motion.div
            whileHover={hoverEffect ? { y: -5, scale: 1.01 } : {}}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className={cn(
                "relative overflow-hidden rounded-2xl border border-white/10 bg-navy-900/40 backdrop-blur-xl shadow-xl",
                "before:absolute before:inset-0 before:bg-glass-gradient before:opacity-100",
                hoverEffect && "hover:border-cobalt-500/50 hover:shadow-cobalt-500/10 hover:shadow-2xl transition-all duration-300",
                className
            )}
            onClick={onClick}
        >
            <div className="relative z-10 h-full">
                {children}
            </div>

            {/* Glow effect on hover */}
            {hoverEffect && (
                <div className="absolute -inset-full top-0 block bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:animate-shine" />
            )}
        </motion.div>
    );
}
